<template>
<div>
    <div class="login_wrap">
        <dl>
            <dt>약관 동의</dt>
            <dd>
                서비스 이용을 위한 약관에 동의해 주세요
            </dd>
        </dl>
        <ul class="login_form">
            <li style="margin-bottom:35px">
                <div class="chk_box">
                    <input type="checkbox" class="chk_box" id="chk1" 
                        true-value="Y" false-value="N"
                        v-model="user.termsServiceYn"
                    >
                    <label for="chk1"></label>
                    <router-link to="/termList">
                        <label for="chk1" class="termFont">프리북 서비스 이용 약관 (필수)</label>
                    </router-link>
                </div>
            </li>
            <li style="margin-bottom:35px">
                <div class="chk_box">
                    <input type="checkbox" class="chk_box" id="chk2" 
                        true-value="Y" false-value="N"
                        v-model="user.termsPrivacyYn"
                    >
                    <label for="chk2"></label>
                    <router-link to="/privacyList">
                        <label for="chk2" class="termFont">개인정보 처리 방침 (필수)</label>
                    </router-link>
                </div>
            </li>
            <li>
                <div class="chk_box">
                    <input type="checkbox" class="chk_box" id="chk3" 
                        true-value="Y" false-value="N"
                        v-model="user.termsMarketingYn"
                    >
                    <label for="chk3"></label>
                    <label for="chk3">마케팅 정보 수신 동의 (필수)</label>
                </div>
            </li>
        </ul>
    </div>
    
    <div class="btn_box_fixed">
        <a class="default_btn1" @click="validate()">회원가입</a>
    </div> 
</div>

</template>

<script>
    export default {
        name:'JoinTerms',
        created() {
            this.$store.commit('SHOW_ONLOAD');
        },
        data() {
            return {
                user: this.$store.state.auth.itemWrite,
            }
        },
        methods: {
            validate () 
            {
                try 
                {
                    if(this.user.termsServiceYn == 'N') throw '프리븍 서비스 이용 약관(필수)에 체크해주세요.';
                    if(this.user.termsPrivacyYn == 'N') throw '개인정보 처리 방침(필수)에 체크해주세요.';
                    if(this.user.termsMarketingYn == 'N') throw '마케팅 정보 수신 동의(필수)에 체크해주세요.';
                } 
                catch (error) 
                {
                    this.$store.commit('OPEN_MODAL', { content:error, btnOne:'확인', })
                    return;
                }

                this.submit();
            },

            submit ()
            {
                this.$store.dispatch('CREATE_USER', this.user)
                .then( () => {
                    this.$router.push('/join/social');
                })
                .catch( (error) => {
                    this.apiCatch(error);
                })
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>